module.exports = __webpack_public_path__ + "img/miOsfatun-responsive.bb73be35.svg";